import * as Yup from 'yup';

const requiredText = () => Yup.string().trim().required('Required');

export const travelValidationSchema = () =>
  Yup.object({
    travelDetails: Yup.object({
      departureId: requiredText(),
      destinationId: requiredText(),
      duration: requiredText(),
      covers: Yup.array()
        .of(
          Yup.object({
            coverID: requiredText(),
            isMandatory: Yup.boolean()
          })
        )
        .required('Required')
    })
  });
